import React from "react";
import { Grid } from "@material-ui/core";
import { useStore } from "../../../store";
import { CreditCustomersTable } from "../CreditCustomerDetails/CreditCustomersTable/CreditCustomersTable";
import { Helmet } from "react-helmet-async";
export const CreditCustomer = () => {
  const [creditCustomers] = useStore("creditCustomers");

  return (
    <>
      <Helmet>
        <title>Credit customers</title>
      </Helmet>
      <Grid
        container
        spacing={2}
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Grid item xs={12}>
          <CreditCustomersTable creditCustomer={creditCustomers} />
        </Grid>
      </Grid>
    </>
  );
};
